module.exports = __webpack_public_path__ + "static/media/ss.de717cff.jpg";